import React, { useState } from 'react'
import { getApiTargetInfo } from 'core'
import { connect } from 'react-redux'
import CommonScreen from 'admin/component/CommonScreen'
import { severity } from 'core/utils'
import { strCol } from '@integec/grid-tools/lib/cols'
import { toSelectionColProps } from '@integec/grid-tools/lib/utils'
import { deleteSolarerrors, getSolarerrors, updateSolarerrors } from 'api/pgads'
import { modifiedDateCol, modifierCol } from 'core/HeaderColTypeProps'
import { Label } from 'core/screen-util'
import { Button, Input, Select } from 'antd'

const title = 'Solar Error Codes Managament'

const SolarErros = _ => {
  const [insertEvent, setInsertEvent] = useState(false)
  const InsertComp = ({ insertData = {}, setInsertData, onAdd, onCancel }) => {
    return (
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: '200px 200px 100px 200px auto auto auto',
          gap: 10,
        }}
      >
        <div>
          <Label style={{ display: 'inline', float: 'right' }}>
            Error Code :
          </Label>
          <span style={{ color: 'red', marginRight: '2px', float: 'right' }}>
            *
          </span>
        </div>

        <Input
          value={insertData.errorcode}
          placeholder="Error Code"
          onChange={e =>
            setInsertData({
              ...insertData,
              errorcode: e.target.value,
            })
          }
        />
        <div>
          <Label style={{ display: 'inline', float: 'right' }}>
            Severity :
          </Label>
        </div>
        <Select
          className="severity"
          value={severity[insertData.severity]}
          style={{ width: '100px' }}
          onChange={value => setInsertData({ ...insertData, severity: value })}
        >
          {Object.keys(severity).map(m => (
            <Select.Option key={m}>{severity[m]}</Select.Option>
          ))}
        </Select>
        <div style={{ gridColumnEnd: 'span 3' }} />
        <div>
          <Label style={{ display: 'inline', float: 'right' }}>
            Error Description :
          </Label>
        </div>
        <Input
          style={{ gridColumnEnd: 'span 3' }}
          value={insertData.error}
          placeholder="Error Description"
          onChange={e =>
            setInsertData({
              ...insertData,
              error: e.target.value,
            })
          }
        />

        <Button type="primary" onClick={() => onAdd(true)}>
          Add
        </Button>
        <Button type="primary" onClick={() => onAdd(false)}>
          Add & Hide
        </Button>
        <Button type="danger" onClick={onCancel}>
          Cancel
        </Button>
      </div>
    )
  }

  return (
    <CommonScreen
      title={title}
      header={Wind2ErrorHeaders}
      saveTask={updateSolarerrors}
      retrieveTask={getSolarerrors}
      deleteTask={deleteSolarerrors}
      autoRetrieve
      // widthOffset={50}
      insertComp={insertEvent && InsertComp}
      insertCompHeight={150}
      onInsertEvent={b => setInsertEvent(b)}
      autoFixColByKey={false}
      headerRowHeight={30}
      sortOptions={Wind2ErrorHeaders}
      defaultInsertData={{ severity: 0 }}
    />
  )
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
})

export default connect(mapStateToProps)(SolarErros)

const Wind2ErrorHeaders = [
  strCol({
    ident: 'errorcode',
    display: 'Error Code',
    isKey: true,
    width: 150,
    // ellipsis: true,
    // alignment: 'left',
    sortOrder: 'asc',
  }),
  strCol({
    ident: 'severity',
    display: 'Severity',
    // isKey: true,
    isFiltered: true,
    sortOrder: 'asc',
    width: 150,
    ...toSelectionColProps(severity),
    isRequired: true,
  }),
  strCol({
    ident: 'error',
    display: ' Description',
    isFiltered: true,
    width: 700,
    ellipsis: true,
    alignment: 'left',
  }),
  modifierCol,
  modifiedDateCol,
]
